
const BUSINESS_NAME = 'TayLord Arms';
const BUSINESS_PHONE = '(843) 209-4304';

const buildContactReply = (c) => {
  const name = c.name || 'there';
  const firstName = name.split(' ')[0];
  const cat = (c.category || '').toLowerCase();
  const subject =
    c.category === 'FFL Transfer'
      ? `Re: Your FFL transfer inquiry — ${BUSINESS_NAME}`
      : c.category
        ? `Re: Your inquiry about ${c.category} — ${BUSINESS_NAME}`
        : `Re: Your message to ${BUSINESS_NAME}`;

  let body;
  if (cat === 'ffl transfer') {
    body =
`Hi ${firstName},

Thanks for reaching out about an FFL transfer. Happy to walk you through the process.

The easiest way to get started is to have the dealer ship to our FFL, and we'll notify you as soon as it arrives. Feel free to reply with any questions or give us a call at ${BUSINESS_PHONE}.

Thanks,
${BUSINESS_NAME}`;
  } else if (cat.includes('cleaning')) {
    body =
`Hi ${firstName},

Thanks for reaching out about cleaning services. We can take care of pistols, rifles, and shotguns with Basic or Advanced (ultrasonic) cleaning.

Just let us know what you'd like done and we'll schedule a drop-off time that works for you. Give us a call at ${BUSINESS_PHONE} or reply here.

Thanks,
${BUSINESS_NAME}`;
  } else {
    body =
`Hi ${firstName},

Thanks for reaching out to ${BUSINESS_NAME}. We received your message and wanted to get back to you right away.

${c.category ? `Regarding "${c.category}" — ` : ''}let us know any additional details and we'll take it from there. Feel free to call us at ${BUSINESS_PHONE} if that's easier.

Thanks,
${BUSINESS_NAME}`;
  }

  return `mailto:${encodeURIComponent(c.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

const buildQuoteReply = (q) => {
  const name = q.name || 'there';
  const firstName = name.split(' ')[0];
  const subject = `Re: Your quote request — ${q.service_type} — ${BUSINESS_NAME}`;
  const body =
`Hi ${firstName},

Thanks for your quote request on your ${q.firearm_type || 'firearm'} for ${q.service_type}.

We reviewed your request${q.timeline ? ` and noted your ${q.timeline} timeline` : ''}. Based on what you described, here's what we can offer:

  • [Estimated price / scope]
  • [Turnaround]
  • [Next steps]

Let us know if this works and we'll get you on the schedule. You can also call us at ${BUSINESS_PHONE}.

Thanks,
${BUSINESS_NAME}`;

  return `mailto:${encodeURIComponent(q.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export { buildContactReply, buildQuoteReply };
